export default __webpack_public_path__ + "static/media/flag-french-polynesia.613d3d49.svg";